import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14 3.125H7.964c-.67 0-1.225 0-1.677.037-.471.038-.908.121-1.32.33a3.38 3.38 0 0 0-1.474 1.476c-.21.411-.293.848-.331 1.319-.037.452-.037 1.008-.037 1.677V14h1.75V8c0-.715 0-1.198.031-1.57.03-.364.083-.544.146-.668.156-.305.405-.554.71-.71.124-.063.304-.116.667-.146.373-.03.856-.031 1.571-.031h6z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.8 7h4.4c.98 0 1.47 0 1.845.19.329.169.596.436.764.766C17 8.33 17 8.82 17 9.8v4.4c0 .98 0 1.47-.19 1.845a1.75 1.75 0 0 1-.765.764C15.67 17 15.18 17 14.2 17H9.8c-.98 0-1.47 0-1.844-.19a1.75 1.75 0 0 1-.765-.765C7 15.67 7 15.18 7 14.2V9.8c0-.98 0-1.47.19-1.844a1.75 1.75 0 0 1 .766-.765C8.33 7 8.82 7 9.8 7m4.4 1.75H9.8c-.519 0-.803.001-1.007.018l-.023.002-.002.023c-.017.204-.018.488-.018 1.007v4.4c0 .519.001.803.018 1.007l.002.023.023.002c.204.017.488.018 1.007.018h4.4c.519 0 .803-.001 1.007-.018l.023-.002.002-.023c.017-.204.018-.488.018-1.007V9.8c0-.519-.001-.803-.018-1.007l-.002-.023-.023-.002A14 14 0 0 0 14.2 8.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }